export const RecordIcon = (
  <svg className="size-5" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15.5825" cy="15.5823" r="15.1406" fill="white" fillOpacity="0.63" />
    <circle cx="15.5823" cy="15.5823" r="5.74297" fill="#EB5757" />
  </svg>
);
